import React, { Component } from 'react';
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import SimpleReactValidator from 'simple-react-validator';
import { toast } from 'react-toastify';
import { updateUserInfo,getWebSessionId } from "../../actions/user";


import { getOrderInfo, saveOrderInfo, getStoreCreditInfo,segregateCart } from '../../actions/checkout'
import { clearCartInfo } from '../../actions/cart'
import Success from "./success-page"
//import Success from "./csa-success";

import { Link, withRouter } from 'react-router-dom'
import axios from "axios";


const getPaymentGatewayDetailsURL = `${process.env.REACT_APP_API_URL}mobileshop/csapayment-gateway/get-payment-gateway-details`;

const getRazorPayOrderURL = `https://api.razorpay.com/v1/orders`;

function loadScript(src) {
	return new Promise((resolve) => {
		const script = document.createElement('script')
		script.src = src
		script.onload = () => {
			resolve(true)
		}
		script.onerror = () => {
			resolve(false)
		}
		document.body.appendChild(script)
	})
}

class PaymentPage extends Component {

    constructor() {
        super()
        this.state = {
            payment_mode: 'pay_now',
            creditSelected: [],
            isAppliedCredits: false,
            razorpay_details: null,
            payment_gateway_details: null,
            payment_failed: false,
        }
        this.validator = new SimpleReactValidator();
    }

    componentDidMount() {
        const { updateUserInfo, connection_id, userInfo, web_session_trans_id, orderInfo, storeCredit } = this.props;
        if (orderInfo === null || orderInfo === "null") {
            this.props.history.push("/cart");
            // toast.error("Please Try Again")
        } else {
            const storeOptions = {
                connection_id,
                web_session_trans_id,
                consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                order_value: orderInfo.RID_NET_AMT,
                query_action: "REMOVE",
            }
            this.props.getStoreCreditInfo(storeOptions)
            const storeOptionsAfter = {
                connection_id,
                web_session_trans_id,
                consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                order_value: orderInfo.RID_NET_AMT,
                query_action: "GET",
            }
            setTimeout(() => {
                this.props.getStoreCreditInfo(storeOptionsAfter);
            }, 0)
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.storeCredit !== this.props.storeCredit) {
            const selected = this.state.creditSelected;
            nextProps.storeCredit && nextProps.storeCredit.settlement_data.map((item, index) => {
                if (parseInt(item.TENDER_OFFSET_AMT) > 0) {
                    selected.push(item.TTM_TENDER_TYPE_CD)
                }
            })
            if (selected.length <= 0) {
                this.setState({
                    creditSelected: selected,
                })
            } else {
                this.setState({
                    creditSelected: selected,
                    isAppliedCredits: true,
                })
            }

        }
    }

    // before procressing payment
    async getPaymentGatewayDetails(orderAmt, orderCurrency) {
        const { connection_id } = this.props
        const res = await axios.get(getPaymentGatewayDetailsURL, {
            params: {
                connection_id,
                order_value: orderAmt,
                currency_code: orderCurrency
            },
        });
        if (res.data.ack === "Success") {
              return res.data.results
        }
        else if (res.data.ack === "Failure") {
            toast.error(`Failed - ${res.data.status.message}`);
            return false
          }
    }


  
    
    async displayRazorpay() {
        const {tenant_details, user_details} = this.props
		const res = await loadScript(this.state.payment_gateway_details.STF_REDIRECTION_URL)
            if (!res) {
			alert('Razorpay SDK failed to load. Are you online?')
			return
		}
		const options = {
			key:  this.state.payment_gateway_details.STF_PAYMENT_KEY_ID,
			currency: this.state.razorpay_details.currency,
			amount: parseInt(this.state.razorpay_details.amount),
            order_id:  this.state.razorpay_details.id,
            payment_capture: 1,
			name: tenant_details && tenant_details.STE_ECOM_BRAND_NAME,
            // description: 'Olabi PhoneShop advance',
            image: this.props.logo,
            // image: `${process.env.PUBLIC_URL}/assets/images/blog/1.jpg`,
			handler:  (response) => {
               ///  console.log("raxor", response)
				// alert(response.razorpay_payment_id)
				// alert(response.razorpay_order_id)
                // alert(response.razorpay_signature)
                    this.handleSaveOrder(response)

            }, 
            prefill: {
				name: `${user_details.COM_FNAME} ${(user_details.COM_LNAME === null ) ?  "" : user_details.COM_LNAME }` ,
				email: user_details.COM_EMAIL_ID,
				contact: user_details.COM_CONSUMER_MOBILE_NO,
			}
		}
		const paymentObject = new window.Razorpay(options)
		paymentObject.open()
	}

    async handlePayNow(event) {
        // loading inital state
        // make 2 api calls 
        // api call for razor show razer pay frame
        // show loading for payment
        // if succes show success page
        // else show payment failed page
        event.preventDefault();
        if (this.props.storeCredit.AMOUNT_PAYABLE == 0 || this.state.payment_mode === 'cod'){
            this.handleSaveOrder()
        } else{
            const results =  await this.getPaymentGatewayDetails(this.props.storeCredit.AMOUNT_PAYABLE, "INR");
             if (results.payment_gateway_details && results.razorpay_details){
                 // raxy pay call
                 this.setState({
                     payment_gateway_details : results.payment_gateway_details,
                     razorpay_details : results.razorpay_details
                 }, async () =>{
                     this.displayRazorpay()
                 })
             }
             else {
                 this.setState({
                     payment_failed: true
                 })
             }
        }
    }

    async handleSaveOrder (info = {}) {

        const { userInfo, selectedStore, orderInfo, connection_id } = this.props
        

         
         const options = {
            connection_id: connection_id,
            consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
            consumer_name: userInfo.COM_FNAME,
            web_session_trans_id: this.props.web_session_trans_id,
        }
        localStorage.removeItem('mobile_no');
        const or_no =  await this.props.segregateCart(options)
        if(or_no === 'success'){
          // alert( this.props.segregateCartData.substr(14).slice(0,-2))
           const options1 = [{
            connection_id: connection_id,
            co_order_no:this.props.segregateCartData.substr(14).slice(0,-2),
            consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
            consumer_full_name: userInfo.COM_FNAME,
            web_session_trans_id: this.props.web_session_trans_id,
            delivery_mode: "H",
            payment_mode: "T",
          /*   user_logged_in_store_id: selectedStore.ASM_ASSOC_CD,
            booking_store_id: selectedStore.ASM_ASSOC_CD,
            pickup_store_id:    selectedStore.ASM_ASSOC_CD, */
            user_logged_in_store_id: "",
            booking_store_id: "",
            pickup_store_id:  "",

            cash_received: "",
            cash_return: "",
            cod_amount: (this.state.payment_mode === 'cod' ) ?  this.props.storeCredit.AMOUNT_PAYABLE : "",
            order_type: orderInfo.RID_CART_ORDER_TYPE && orderInfo.RID_CART_ORDER_TYPE.toUpperCase(),
            order_value: orderInfo.RID_NET_AMT,
            delivery_address: {
                salutation: userInfo.COM_SALUTATION,
                first_name: userInfo.COM_FNAME,
                last_name: (userInfo.COM_LNAME === null ) ?  "" : userInfo.COM_LNAME,
                mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                email_id: userInfo.COM_EMAIL_ID,
                address_1: userInfo.COM_ADDRESS1,
                address_2: userInfo.COM_ADDRESS2,
                address_3: userInfo.COM_ADDRESS3,
                city: userInfo.COM_TOWN_NAME,
                state_code : userInfo.COM_STATE_CD,
                state_id: userInfo.COM_STATE_NAME,
                country_code: userInfo.COM_CONTRY_NAME,
                pin_code: userInfo.COM_PIN
            },
            billing_address: {
                email_id: userInfo.COM_BILL_TO_EMAIL_ID,
                address_1: userInfo.COM_BILL_TO_ADDRESS1,
                address_2: userInfo.COM_BILL_TO_ADDRESS2,
                address_3: userInfo.COM_BILL_TO_ADDRESS3,
                city: userInfo.COM_BILL_TO_TOWN_NAME,
                state_id: userInfo.COM_BILL_TO_STATE_NAME,
                country_code: userInfo.COM_BILL_TO_CONTRY_NAME,
                pin_code: userInfo.COM_BILL_TO_PIN
            },
            tender_details :  (this.state.payment_mode !== 'cod' && this.props.storeCredit.AMOUNT_PAYABLE !== '0' ) ? [{
                settle_type: this.state.payment_gateway_details.STF_PAYMENT_TENDER_TYPE_CD,
                tender_currency_code: this.state.razorpay_details.currency,
                tender_amount :  this.props.storeCredit.AMOUNT_PAYABLE,
                payment_gateway_payment_id : info.razorpay_payment_id,
                payment_gateway_order_id: info.razorpay_order_id,
                payment_gateway_signature : info.razorpay_signature,
                payment_gateway_associate: this.state.payment_gateway_details.STF_TENDER_FRANCHISEE_NAME,
                payment_order_id: this.state.payment_gateway_details.ORDER_ID,

            }] : []
        }]
    //console.log(options1)
       this.props.saveOrderInfo(options1)
        }
        this.props.getWebSessionId(connection_id)

    }

    // store credit handlers
    applyStoreCredits = () => {
        const { connection_id, userInfo, web_session_trans_id, orderInfo } = this.props;
        if (this.state.isAppliedCredits) {
            const storeOptions = {
                connection_id,
                web_session_trans_id,
                consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                order_value: orderInfo.RID_NET_AMT,
                query_action: "REMOVE",
            }
            this.props.getStoreCreditInfo(storeOptions)
            this.setState({
                isAppliedCredits: false,
                creditSelected: []
            })
        } else {
            const tender_details = []
            this.state.creditSelected.map(item => {
                tender_details.push({ "settle_type": item })
            });

            const storeOptions = {
                connection_id,
                web_session_trans_id,
                consumer_mobile_no: userInfo.COM_CONSUMER_MOBILE_NO,
                order_value: orderInfo.RID_NET_AMT,
                query_action: "APPLY",
                tender_details
            }
            this.props.getStoreCreditInfo(storeOptions)
            
            this.setState({
                isAppliedCredits: true
            })
        }

    }

    updateCreditSelected = (event) => {
        const selected = this.state.creditSelected;
        if (selected.includes(event.target.id)) {
            var index = selected.indexOf(event.target.id);
            selected.splice(index, 1)
        } else {
            selected.push(event.target.id)
        }
        this.setState({
            creditSelected: selected
        })
    }

    render() {
        const { orderInfo,ssuccessLoading, success, symbol, storeCredit, storeCreditLoading,successLoading } = this.props;
        const {  payment_failed } = this.state;
        if (storeCreditLoading ) {
            return (
                <div>
                    <div className="product-wrapper-grid">
                        <div className="container-fluid">
                            <div className="loading-cls"></div>
                        </div>
                    </div>
                </div>
            )
        }

        if (payment_failed){
            return <div>Payment Failed! </div>
        }

        if (!!success) {
            // 
            return <>
                <Success message={success.message} loading={ssuccessLoading} {...this.props} />
            </>
        }

        return (
            <div>

                {/*SEO Support*/}
                <Helmet>
                <title>{this.props.customer_name}  | Checkout Page</title>
                    <meta name="description" content="" />
                </Helmet>
                {/*SEO Support End */}
                <section className="m-0 p-0">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-sm-12 col-lg-6" style={{marginTop: "2%"}}>
                                <div className="custom-title">
                                    <span>Choose Payment Method</span>
                                </div>
                                <div className="mini-title-divider" style={{ marginBottom: 0 }}></div>
                                <div className="payment-header">
                                    <div>
                                        <span>Order Value:</span>
                                    </div>
                                    <div>
                                        <span>{symbol} {orderInfo.RID_NET_AMT && orderInfo.RID_NET_AMT}</span>
                                    </div>
                                </div>
                                {storeCredit.settlement_data.length !== 0 && 
                                <div className={this.state.isAppliedCredits ? "opacity-4": ""}>
                                    <table className="table table-responsive-xs payment-table">
                                        <thead>
                                            <tr className="table-head">
                                                <th scope="col">Available Store Credits</th>
                                                <th scope="col">Amount</th>
                                                <th scope="col">Applied Amount</th>
                                            </tr>
                                        </thead>
                                        {storeCredit && storeCredit.settlement_data.map((item, index) => {
                                            return (
                                                <tbody key={index}>
                                                    <tr>
                                                        {/* <td>{item.Credits}</td> */}
                                                        <td>
                                                            <label disabled htmlFor={item.TTM_TENDER_TYPE_CD} onChange={(e) => this.updateCreditSelected(e)}>
                                                                <input className="checkbox_animated" type="checkbox" id={item.TTM_TENDER_TYPE_CD}  disabled={this.state.isAppliedCredits? true: false} name={item.TTM_TENDER_TYPE_CD}
                                                                    checked={this.state.creditSelected.includes(item.TTM_TENDER_TYPE_CD) ? true : false} />
                                                                {item.TTM_TENDER_TYPE_DESC}
                                                            </label>
                                                        </td>
                                                        <td>{item.TENDER_BALANCE_AMT}</td>
                                                        <td>
                                                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                                <div>{parseInt(item.TENDER_OFFSET_AMT) === 0 ? "-" : parseInt(item.TENDER_OFFSET_AMT)}</div>
                                                                <div>{parseInt(item.TENDER_OFFSET_AMT) === 0 ? "" : <input className="checkbox-without-border" type="checkbox" id="store-credits" name="store-credits" disabled checked />}</div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            )
                                        })}
                                    </table>
                                </div>
                                }
                                
                                {/* <div className="cl-12 pull-right" onClick={this.applyStoreCredits}>{this.state.creditSelected.length <= 0 ? "" : this.state.isAppliedCredits ? "Remove Store Credits" : "Apply Store Credits"}</div> */}
                                {storeCredit.settlement_data.length !== 0 && 
                                <>
                                <div className="payment-apply-credit">
                                    <span onClick={this.applyStoreCredits}>
                                    {this.state.creditSelected.length <= 0 ? "" : this.state.isAppliedCredits ? "Reset Store Credits" : "Apply Store Credits"}
                                    </span>
                                </div>
                                <div className="custom-divider" style={{marginBottom: 0}}></div>
                                <div className="payment-store-credits">
                                    <div style={{float:'left'}}>
                                        <span>Less store credits:</span>
                                    </div>
                                    <div style={{float:'right'}}>
                                        <span>{symbol} {storeCredit.TOTAL_STORE_CREDITS_APPLIED}</span>
                                    </div>
                                </div>
                                <div className="payment-total">
                                    <div style={{float:'left'}}>
                                        <span>Amount Payable (incl. tax):</span>
                                    </div>
                                    <div style={{float:'right'}}>
                                        <span>{symbol} {storeCredit.AMOUNT_PAYABLE}</span>
                                    </div>
                                </div>
                                </>
                                }
                                <div className="payment-footer">
                                    <div className="payment-options" style={this.props.storeCredit.AMOUNT_PAYABLE == 0 ? ({display: "none"}) : ({display: "block"})}>
                                        <div style={{ padding: "10px 0px" }}>
                                            <label htmlFor="pay_now" onClick={() => { this.setState({ payment_mode: "pay_now" }) }}>
                                                <input className="radio_animated" type="radio" id="pay_now" name="pay_now"
                                                    checked={this.state.payment_mode === 'pay_now'} />
                                                <span>Pay Now</span>
                                            </label>
                                        </div>
                                            {/* <div   style={this.props.storeCredit.COD_ENABLED !== 'Y' ? {display: "none"} : {display: "block",padding: "10px 0px"}} >
                                                <label htmlFor="cod" onClick={() => { this.setState({ payment_mode: "cod" }) }}>
                                                    <input className="radio_animated" type="radio" id="cod" name="cod"
                                                        checked={this.state.payment_mode === 'cod'} />
                                                    <span>Cash On Delivery</span>
                                                </label>
                                            </div> */}
                                    </div>
                                    <div className="payment-buttons">
                                        <div style={{ flexGrow: 7, textAlign: "left" }}  onClick={(event) => this.handlePayNow(event)}>
                                            <button className="btn btn-solid" 
                                            disabled={this.props.successLoading}
                                            style={{ width: "100%", padding: "12px 0px" }}>{this.props.successLoading ? "Loading" : "Continue"}</button>
                                        </div>
                                        <div style={{ flexGrow: 3, textAlign: "right" }}>
                                            <button className="new-btn new-btn-solid" style={{ width: "90%" }}  onClick={() => this.props.history.goBack()}>Back</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    symbol: state.data.symbol,
    userInfo: state.user.user_details,
    connection_id: state.tenant.connection_id,
    orderInfo: state.checkout.orderInfo || null,
    cartItems: state.cart.cartItems,
    web_session_trans_id: state.user.web_session_trans_id,
    selectedStore: state.store.selectedStore,
    success: state.checkout.success,
    successLoading: state.checkout.successLoading,
    ssuccessLoading: state.checkout.ssuccessLoading,
    loading: state.checkout.loading,
    error: state.checkout.error,
    storeCredit: state.checkout.storeCredit,
    storeCreditLoading: state.checkout.storeCreditLoading,
    storeCreditError: state.checkout.storeCreditError,
    customer_name: state.tenant.tenant_details.STE_ECOM_BRAND_NAME || "",
    tenant_details: state.tenant.tenant_details,
    user_details: state.user.user_details,
    logo: state.tenant.tenantLogoURL,
    segregateCartData: state.checkout.segregateCartData,


})

export default connect(
    mapStateToProps,
    { getOrderInfo, saveOrderInfo, clearCartInfo,getWebSessionId, updateUserInfo, getStoreCreditInfo,segregateCart }
)(withRouter(PaymentPage))